<template lang="pug">
    section.abonement
        el-row.no-margin(:gutter="20")
            el-col(:sm="12")
                .api-keys(v-if="needsMapBox || needsOttoMarket || needsGoogleRecaptcha || needsStripe || needsPayPal || needsUps || shop")
                    MapBoxKey(v-if="needsMapBox" :cms="form")
                    GoogleRecaptchaKeys(v-if="needsGoogleRecaptcha" :cms="form")
                    StripeKeys(v-if="needsStripe" :cms="form")
                    OttoMarketKeys(v-if="needsOttoMarket" :cms="form")
                    .paypal-api-keys(v-if="needsPayPal || needsUps")
                        h4
                            i.el-icon-fa-wallet.fas
                            | {{ $t('PayPal Checkout') }}
                        .paypal-env
                            h5.paypal-env__label {{ $t('Production') }}
                            PayPalKeys(:cms="form")
                        .paypal-env
                            h5.paypal-env__label {{ $t('Sandbox') }}
                            PayPalKeys(:cms="form" env="sandbox")
                    UpsKeys(v-if="needsUps" :cms="form")
                    FiskalyConfiguration(:cms="form")
            el-col(:sm="12")
                CmsApiTokens
                .groups
                    transition-group(name="slide-decent-vertical")
                        .row(
                            v-for="(group, i) in groups" :key="i"
                            v-if="checkConditions(group)"
                        )
                            transition-group.flex(name="slide-decent-vertical")
                                SettingField.setting-field(
                                    v-for="field in group.fields"
                                    v-if="checkConditions(field)"
                                    :key="field.key"
                                    :field="field"
                                    :setting-values="settingValues"
                                )
                el-collapse(accordion v-if="blocks && blocks.length")
                    transition-group(name="slide-decent-vertical")
                        el-collapse-item(
                            v-for="block in blocks" :key="block.key"
                            v-if="checkConditions(block)"
                            :title="block.name"
                            :name="block.key"
                        )
                            transition-group(name="slide-decent-vertical")
                                .row(
                                    v-for="(group, i) in block.groups" :key="block.key+i"
                                    v-if="checkConditions(group)"
                                )
                                    transition-group.flex(name="slide-decent-vertical")
                                        SettingField.setting-field.no-margin(
                                            v-for="field in group.fields"
                                            v-if="checkConditions(field)"
                                            :key="field.key"
                                            :field="field"
                                            :setting-values="settingValues"
                                        )
</template>

<script>

import _ from 'lodash'

import { useSettingsStore } from '@/stores'

import MapBoxKey from './Partials/MapBoxKey'
import OttoMarketKeys from './Partials/OttoMarketKeys'
import GoogleRecaptchaKeys from './Partials/GoogleRecaptchaKeys'
import PayPalKeys from './Partials/PayPalKeys'
import StripeKeys from './Partials/StripeKeys'
import Domain from './Partials/Domain'

import SettingField from './Partials/SettingField'
import UpsKeys from './Partials/UpsKeys'
import FiskalyConfiguration from './Partials/FiskalyConfiguration'
import CmsApiTokens from './CmsApiTokens'

export default {
    name: 'AbonementAPI',
    data() {
        return {}
    },
    components: {
        Domain,
        MapBoxKey,
        OttoMarketKeys,
        GoogleRecaptchaKeys,
        StripeKeys,
        PayPalKeys,
        // JsSnippets,
        // CssSnippets,
        SettingField,
        UpsKeys,
        CmsApiTokens,
        FiskalyConfiguration,
    },
    computed: {
        settings() {
            const settings = _.get(this.form, 'config.template.settings') || []
            return settings.find(el => el.key === 'api')
        },
        blocks() {
            return _.get(this.settings, 'blocks') || []
        },
        groups() {
            return _.get(this.settings, 'groups') || []
        },
        template: {
            get() {
                return _.get(this.form, 'config.template')
            },
            set(value) {
                useSettingsStore().setFormTemplate(value)
            }
        },
        requirements() {
            return _.get(this.template, 'requirements') || []
        },
        needsMapBox() {
            return !!this.requirements.find(requirement => {
                return requirement.key === 'mapbox' && requirement.context === 'cms'
            })
        },
        needsOttoMarket() {
            const requirement = this.requirements.find(requirement => {
                return requirement.key === 'otto-market' && requirement.context === 'shop'
            })
            return !!requirement && this.shop && this.checkConditions(requirement)
        },
        needsGoogleRecaptcha() {
            return !!this.requirements.find(requirement => {
                return requirement.key === 'google-recaptcha-v3' && requirement.context === 'cms'
            })
        },
        needsPayPal() {
            return this.shop && this.requirements.find(requirement => {
                return requirement.key === 'paypal-checkout' && requirement.context === 'shop'
            })
        },
        needsStripe() {
            return this.shop && this.requirements.find(requirement => {
                return requirement.key === 'stripe' && requirement.context === 'shop'
            })
        },
        needsUps() {
            return !!this.requirements.find(requirement => {
                return requirement.key === 'ups-account-nr' && requirement.context === 'shop'
            })
        },
        hasDesignSettings() {
            const settings = _.get(this.form, 'config.template.settings') || []
            if (settings.find(el => el.key === 'design')) return true
            else return false;
        },
        enabledExtensions() {
            const supportedExtensions = _.get(this.form, 'config.template.extensions') || [];
            const activeExtensions = (_.get(this.form, 'extensions') || []).map(extension => extension.key);
            return ['status-logs', ...supportedExtensions].filter(extension => activeExtensions.includes(extension));
        },
        shop: {
            get() {
                const extensions = this.form.extensions || []
                return !!extensions.find(extension => extension.key === 'shop')
            },
            set(value) {
                if (value === true) {
                    useSettingsStore().createFormShop()
                    useSettingsStore().addFormExtension({ key: 'shop' })
                } else {
                    // store.commit(`account/form/administrator/deleteShop`, this.index)
                    useSettingsStore().removeFormExtension({ key: 'shop' })
                }
            }
        },
        form() {
            return useSettingsStore().form;
        },
        options() {
            return useSettingsStore().options;
        },
        settingValues() {
            return useSettingsStore().values;
        }
    },
    methods: {
        checkConditions(setting) {
            let valid = true

            // eslint-disable-next-line no-unused-vars
            const settings = this.settingValues;
            const enabledExtensions = this.enabledExtensions;
            try {
                const conditions = setting.conditions
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return

                        const { type, condition } = o
                        switch (type) {
                            case 'eval':
                                valid = eval(condition)
                                break;

                            default:
                                valid = false
                        }
                    })
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false
            }

            return valid
        },
    }
}
</script>

<style lang="sass" scoped>
// Every API/config block is ONE clean card. Target the block roots EXPLICITLY
// (not `> div`): PayPalKeys' own root is also `.api-keys` and inherits this
// component's scope, so a `> div` rule would card each inner el-form-item ("box
// in box"). The sectioned mailbox is a single card too — its Authentication /
// Sending / Receiving / Signature groups are flat dividers inside, not cards.
.api-keys
    ::v-deep
        > .map-box-key,
        > .google-recaptcha-keys,
        > .smtp-credentials,
        > .stripe-api-keys,
        > .otto-market-keys,
        > .paypal-api-keys,
        > .fiskaly-configuration
            border: 1px solid #ebeef5
            border-radius: 8px
            background: #fff
            padding: 18px 20px
            box-sizing: border-box
            margin-bottom: 14px
            position: static
            // Replace the legacy left-accent bar with the card.
            &:before
                display: none
            // Unify every box title with the mailbox-section titles.
            h4
                display: flex
                align-items: center
                font-size: .72rem
                font-weight: 700
                text-transform: uppercase
                letter-spacing: .04em
                color: $color-grey-text
                margin: 0 0 16px
                padding-bottom: 10px
                border-bottom: 1px solid #f2f6fc
                p
                    margin: 0
                    small
                        font-weight: 700
            // Fixed-width icons so glyphs of different natural widths align.
            h4 i
                color: $--color-primary
                margin-right: 8px
                width: 1.1em
                text-align: center
                flex: 0 0 auto
            // Collapse the trailing field margin so bottom padding matches the top.
            .el-form-item:last-child
                margin-bottom: 0
        // PayPal Production / Sandbox: identical sub-section labels.
        > .paypal-api-keys
            .paypal-env + .paypal-env
                margin-top: 20px
            .paypal-env__label
                font-size: .68rem
                font-weight: 700
                text-transform: uppercase
                letter-spacing: .04em
                color: $color-grey-text
                margin: 0 0 12px
</style>
